<form [formGroup]="advisors" id="advisors" (ngSubmit)=onSubmit(advisors)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container"
		[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
			(editQuestionChange)="editQuestionChange($event)">

			<!--intro-->
			<question [qID]="'0'">
				<div>
					<div class="d-flex justify-content-center">
						<h1 class="app-title-xxxlarge-blue">
							{{'ADVISORS.INTRO.OPENING1'|translate}}<br>
							{{'ADVISORS.INTRO.OPENING2'|translate}}<br>
							{{'ADVISORS.INTRO.OPENING3'|translate}}<br><br>
						</h1>
					</div>
				</div>
				<div *ngIf="!ifIsLoginAdvisor()">
					<button (click)="setAdvisorProcess(1)" class="app-button button-primary">{{'START.START-PRIVATE' |
						translate}}</button>
					<button (click)="setAdvisorProcess(2)"
						class="mr-3 app-button button-secondery">{{'START.CONTINUE-PROCESS' | translate}}</button>
				</div>
				<div class="mt-3">
					<a href="https://sc.mizrahi-tefahot.co.il/CycleMashkantaClient/"
						class="app-link c-drak app-text-decoration app-title-small-bold mt-5">
						{{'START.CYCLE-LINK' |translate}}</a>
				</div>
			</question>

			<!--tz-->
			<question [qID]="'1'">
				<div class="padding-right">
					<app-messages *ngIf="isError !== ''" [msgArr]="[{text: isError}]"></app-messages>
				</div>
				<div class="padding-right">
					<app-messages *ngIf="errorInConfirm !== ''" [msgArr]="[{text: errorInConfirm}]"></app-messages>
				</div>
				<app-otp class="text-right" [userId]="tzAdvisor" *ngIf="hasLoggedInAdvisor">
				</app-otp>
				<div *ngIf="!hasLoggedInAdvisor">
					<h1 class="app-title-xxxlarge-blue">{{"ADVISORS.Q2.QUESTION"|translate}}</h1>
					<div class="row justify-content-center">
						<div class="col-12 col-sm-6 col-md-6 col-lg-3 input-wrapper">
							<app-animated-input formControlName="idNumber" placeholder="{{'ADVISORS.Q2.PH1'|translate}}"
								maxLength="9" [attAriaLabel]="'ADVISORS.Q2.PH1'|translate"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('idNumber').hasError('required') && submitted" role="alert">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('idNumber').hasError('invalidId') && !advisors.get('idNumber').hasError('required') && submitted"
								role="alert">{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
						</div>
					</div>
				</div>
				<div *ngIf="!hasLoggedInAdvisor" class="d-flex justify-content-center mt-md-5 mt-2">
					<button type="submit" class="app-button"
						[ngClass]="{'button-primary': advisors.valid && qID=='1', 'button-primary-disabled': !(advisors.valid && qID=='1')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<!--name-->
			<question [qID]="'2'">
				<div>
					<h1 class="app-title-xxxlarge-blue">{{ 'ADVISORS.Q1.QUESTION' | translate }}</h1>
					<div class="row justify-content-sm-center justify-content-center">
						<div class="col-12 col-lg-3 col-md-4 col-sm-6  mx-1 form-group">
							<app-animated-input formControlName="firstName"
								placeholder="{{ 'ADVISORS.Q1.INPUT1_PH' | translate }}" [animatedLabel]="true"
								[attAriaLabel]="'ADVISORS.Q1.INPUT1_PH'|translate"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('firstName').hasError('required') && submitted" role="alert">{{
								'ADVISORS.Q1.REQUIRED1' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('firstName').hasError('pattern') && submitted" role="alert">{{
								'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>

						</div>
						<div class="col-12 col-lg-3 col-md-4 col-sm-6 col-lg-3 mx-1 form-group">
							<app-animated-input formControlName="lastName"
								placeholder="{{ 'ADVISORS.Q1.INPUT2_PH' | translate }}" [animatedLabel]="true"
								[attAriaLabel]="'ADVISORS.Q1.INPUT2_PH'|translate"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('lastName').hasError('required') && submitted" role="alert">{{
								'ADVISORS.Q1.REQUIRED2' | translate }}</label>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('lastName').hasError('pattern') && submitted" role="alert">{{
								'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
						</div>
					</div>
					<div class="d-flex justify-content-center mt-md-5 mt-2">
						<button type="submit" class="app-button"
							[ngClass]="{'button-primary': advisors.valid && qID=='1', 'button-primary-disabled': !(advisors.valid && qID=='1')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<!--phone-->
			<question [qID]="'3'">
				<div class="text-center">
					<h1 class="app-title-xxxlarge-blue">{{"ADVISORS.Q3.QUESTION"|translate}}</h1>
					<!-- <inner-tooltip [qTitle]="'ADVISORS.Q3.TOOLTIP'|translate"
						[text]="'ADVISORS.Q3.TOOLTIP_TEXT'|translate" class="m-start-tooltip app-title-small-blue"></inner-tooltip> -->
				</div>
				<div>
					<div class="d-flex justify-content-center">
						<div class="m-1">
							<phone-number [customClass]="'user-details'" [mobilePrefixOnly]="isMobilePrefixOnly"
								formControlName="phoneNumber" [(isMobile)]="isMobilePhone"
								(change)="setValidatorsArray()"
								[attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate"
								[attr.aria-invalid]="!advisors.get('phoneNumber').valid &&  submitted">
							</phone-number>
							<label class="app-error"
								*ngIf="advisors.get('phoneNumber').hasError('minlength') && submitted" role="alert">{{
								'COMMON.PHONE_MIN_CHARS' | translate }}</label>
							<label class="app-error"
								*ngIf="advisors.get('phoneNumber').hasError('required') && submitted" role="alert">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error"
								*ngIf="advisors.get('phoneNumber').hasError('pattern') && submitted" role="alert">{{
								'COMMON.PHONE_NUM_PATTERN_ERROR' | translate }}</label>
						</div>
					</div>
					<div class="d-flex justify-content-center mt-md-5 mt-2">
						<button type="submit" class="app-button"
							[ngClass]="{'button-primary': advisors.valid && qID=='3', 'button-primary-disabled': !(advisors.valid && qID=='3')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<!--consulting Company-->
			<question [qID]="'4'">
				<div>
					<h1 class="app-title-xxxlarge-blue">{{"ADVISORS.Q4.QUESTION"|translate}}</h1>
					<div class="d-flex justify-content-center">
						<div class="d-flex flex-column justify-content-center">
							<app-mat-autocomplete [data]="cities" formControlName="consulting"
								placeholder="{{'ADVISORS.Q4.PH1'|translate}}"></app-mat-autocomplete>
							<label class="app-error text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('consulting').hasError('required') && submitted" role="alert">{{
								'COMMON.FIELD_REQUIRED' | translate }}</label>
							<label class="app-error text-center text-md-right mr-md-2 mr-0"
								*ngIf="advisors.get('consulting').hasError('isNotInList') && !advisors.get('consulting').hasError('required') && submitted"
								role="alert">{{'ADVISORS.Q5.NOT_IN_LIST_ERROR' | translate}}</label>
						</div>
					</div>

					<div class="d-flex justify-content-center mt-md-5 mt-2">
						<button type="submit" class="app-button"
							[ngClass]="{'button-primary': advisors.valid && qID=='4', 'button-primary-disabled': !(advisors.valid && qID=='4')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<!--tz customer-->
			<question [qID]="'5'">
				<div *ngIf="!draftNotExist">
					<div *ngIf="advisorProcess===2">
						<div *ngIf="!isloading">
							<h1 class="app-title-xxxlarge-blue">
								{{'ADVISORS.END.END1'|translate}}<br>
								{{'otp.finish1'|translate}}<br>
								{{'otp.finish2'|translate}}<br>
								{{'ADVISORS.END.END3'|translate}}<br>
								{{'ADVISORS.END.END4'|translate}}<br>
							</h1>
							<!-- <h3 class="app-title-xxxlarge-blue">{{"ADVISORS.Q2.QUESTION"|translate}}</h3> -->
							<div class="row justify-content-center">
								<div class="col-12 col-sm-6 col-md-6 col-lg-3 input-wrapper">
									<app-animated-input formControlName="idNumberCustomer"
										placeholder="{{'ADVISORS.Q2.PH1'|translate}}" maxLength="9"
										[attAriaLabel]="'ADVISORS.Q2.PH1'|translate"></app-animated-input>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
										*ngIf="advisors.get('idNumberCustomer').hasError('required') && submitted"
										role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
									<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
										*ngIf="advisors.get('idNumberCustomer').hasError('invalidId') && !advisors.get('idNumber').hasError('required') && submitted"
										role="alert">{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}</label>
								</div>
							</div>
						</div>
						<div *ngIf="isloading" class="mx-4 mt-md-0 mt-5">
							<app-loader-page [isloading]="isloading"></app-loader-page>
						</div>
					</div>

					<div *ngIf="advisorProcess===2 && !isloading" class="d-flex justify-content-center mt-md-5 mt-2">
						<button type="submit" class="app-button"
							[ngClass]="{'button-primary': advisors.valid && qID=='5', 'button-primary-disabled': !(advisors.valid && qID=='5')}"
							data-button-id="common-proceed-1">{{"COMMON.PROCEED"|translate}}</button>
					</div>
					<div *ngIf="advisorProcess===1" class="d-flex justify-content-center">
						<h1 class="app-title-xxxlarge-blue">
							{{'ADVISORS.END.END1'|translate}}<br>
							{{'ADVISORS.END.END2'|translate}}<br>
						</h1>
					</div>
				</div>
				<button *ngIf="advisorProcess===1 && !draftNotExist" type="submit" class="app-button button-primary"
					data-button-id="common-proceed-2">{{"COMMON.PROCEED"|translate}}</button>
				<div *ngIf="draftNotExist">
					<div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
						<h1 class="app-title-xxlarge mt-1">{{"ADVISORS.ERROR.ERROR1"|translate}}
							<a (click)="NavigateToStart()" class="app-title-xxlarge mt-1 app-text-decoration"
								tabindex="0">
								{{"ADVISORS.ERROR.ERROR2"|translate}}</a>
							{{"ADVISORS.ERROR.ERROR3"|translate}}
							<a href='https://wa.me/972768818861?text="Mortgage Request"'
								class="app-title-xxlarge mt-1 app-text-decoration" tabindex="0">
								{{"ADVISORS.ERROR.ERROR4"|translate}}</a>
						</h1>
					</div>
				</div>
			</question>

		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/advisors/advisors.component.html